import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "item-header" }
const _hoisted_2 = { class: "owner-label" }
const _hoisted_3 = { class: "item-content" }
const _hoisted_4 = {
  key: 0,
  class: "item-replies"
}
const _hoisted_5 = { class: "owner-label" }
const _hoisted_6 = { class: "reply-actions text-right" }
const _hoisted_7 = {
  key: 0,
  class: "reply-counter-number"
}
const _hoisted_8 = {
  key: 1,
  class: "reply-counter-number gray--text"
}
const _hoisted_9 = {
  key: 1,
  class: "reply-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_icon_content = _resolveComponent("notification-icon-content")!
  const _component_notification_owner_content = _resolveComponent("notification-owner-content")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_notification_redirect_content = _resolveComponent("notification-redirect-content")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!

  return (_openBlock(), _createBlock(_component_v_list_item_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createVNode(_component_notification_icon_content, { item: _ctx.item }, null, 8, ["item"]),
          _createTextVNode("  " + _toDisplayString(_ctx.item.ShortDesc), 1)
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_notification_owner_content, {
            item: _ctx.item,
            isOwner: _ctx.isNotificationCreator(_ctx.item)
          }, null, 8, ["item", "isOwner"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.Text), 1),
      (_ctx.item.Replies && _ctx.item.Replies.length && _ctx.item.showReplyItems)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.Replies, (reply) => {
              return (_openBlock(), _createElementBlock("div", {
                key: reply.Id,
                style: {"display":"flow-root"}
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(["reply-item", `${_ctx.showAsCreator(_ctx.item, reply) ? 'provider' : ''}`])
                }, [
                  _createElementVNode("span", null, _toDisplayString(reply.Text), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_notification_owner_content, {
                      item: _ctx.item,
                      reply: reply,
                      isOwner: _ctx.isReplyCreator(_ctx.item, reply)
                    }, null, 8, ["item", "reply", "isOwner"])
                  ])
                ], 2)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isNotificationCreator(_ctx.item))
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              title: "Withdraw Notification",
              class: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.withdrawNotification(_ctx.item)))
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode(" mdi-bell-off ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_notification_redirect_content, {
          item: _ctx.item,
          userId: _ctx.userId,
          isTeamMember: _ctx.isTeamMember,
          isAdmin: _ctx.isAdmin,
          isClient: _ctx.isClient
        }, null, 8, ["item", "userId", "isTeamMember", "isAdmin", "isClient"]),
        (_ctx.item.RepliesCount)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleReplyViewItems(_ctx.item))),
              class: ""
            }, [
              (_ctx.notificationItemNotSeenRepliesCount(_ctx.item) > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.notificationItemNotSeenRepliesCount(_ctx.item)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.item.RepliesCount), 1)),
              _createVNode(_component_v_icon, {
                class: _normalizeClass(["reply-counter-icon", `${_ctx.notificationItemNotSeenRepliesCount(_ctx.item) ? 'red--text' : ''}`]),
                title: "Toggle Replies"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-comment")
                ])),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasReply(_ctx.item))
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 2,
              title: "Reply to Notification",
              class: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleReplyViewItems(_ctx.item)))
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode(" mdi-reply ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.item.showReplyBox)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_TextAreaField, {
              clearable: "",
              label: "Reply to Notification",
              "prepend-inner-icon": "mdi-pencil",
              rows: "5",
              modelValue: _ctx.item.replyText,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.replyText) = $event)),
              onKeydown: [
                _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])),
                _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"]))
              ]
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_btn, {
              class: "detailButton secondary_btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendReply(_ctx.item))),
              loading: _ctx.item.itemLoading
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Send Reply")
              ])),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}